/*!
 * 週期視窗工具（純函式，無 React 依賴）
 *
 * allWeeks：全部週期，最新在前（index 0 = 最新）。
 * windowWeeks：目前套用的視窗（N 週的子集）。
 *
 * 用於「上 N 週 / 下 N 週」導航與「與上一期比較」的前一期視窗計算。
 */

// 把 window 內每一週在 allWeeks 的索引 +step 後回傳新視窗。
// step > 0 = 更舊（往回），step < 0 = 更新（往前）。任一週越界或找不到 → 回 null。
export function shiftWindow(allWeeks, windowWeeks, step) {
  if (!Array.isArray(allWeeks) || !Array.isArray(windowWeeks) || windowWeeks.length === 0) {
    return null;
  }
  const shifted = [];
  for (const w of windowWeeks) {
    const idx = allWeeks.indexOf(w);
    if (idx === -1) return null;
    const nidx = idx + step;
    if (nidx < 0 || nidx >= allWeeks.length) return null;
    shifted.push(allWeeks[nidx]);
  }
  // 依 allWeeks 順序（最新在前）排序，與選擇器慣例一致
  return shifted.slice().sort((a, b) => allWeeks.indexOf(a) - allWeeks.indexOf(b));
}

// 前一個等寬區間（往回 N 週），供「與上一期比較」抓取；歷史不足回 null。
export function previousWindow(allWeeks, windowWeeks) {
  if (!Array.isArray(windowWeeks) || windowWeeks.length === 0) return null;
  return shiftWindow(allWeeks, windowWeeks, windowWeeks.length);
}

// 一次算出導航所需資訊：視窗大小、上一期(更舊)、下一期(更新)、可否移動。
export function windowNav(allWeeks, windowWeeks) {
  const size = Array.isArray(windowWeeks) ? windowWeeks.length : 0;
  const earlier = size ? shiftWindow(allWeeks, windowWeeks, size) : null;
  const later = size ? shiftWindow(allWeeks, windowWeeks, -size) : null;
  return { size, earlier, later, canEarlier: !!earlier, canLater: !!later };
}

// 成長率：(current - previous) / |previous|。previous 缺/為 0 回 null。
export function growthPct(current, previous) {
  if (
    previous === null ||
    previous === undefined ||
    previous === 0 ||
    current === null ||
    current === undefined ||
    Number.isNaN(current) ||
    Number.isNaN(previous)
  ) {
    return null;
  }
  return ((current - previous) / Math.abs(previous)) * 100;
}
